export const sizeGuideClick = 'sizeGuideClick';
export const howToMeasure = 'howToMeasure';
export const styliticsJumpLink = 'styliticsJumpLink';
export const share = 'shareButton';
